"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _draftJs = require("draft-js"),
    _utils = require("../../../../../../../../../utils"),
    _Viewers = _interopRequireDefault(require("./Viewers")),
    _AddReply = _interopRequireDefault(require("../../../../AddReply"));

require("../styles/_comment-controls.scss");

function _createSuper(Derived) {
  return function () {
    var result,
        Super = (0, _getPrototypeOf2["default"])(Derived);

    if (_isNativeReflectConstruct()) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else result = Super.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (e) {
    return !1;
  }
}

var Controls = function (_Component) {
  function Controls(props) {
    var _this;

    return (0, _classCallCheck2["default"])(this, Controls), _this = _super.call(this, props), _this.handleToggleEditMode = (0, _lodash["default"])(function (_ref) {
      var toggle = _ref.toggle;
      return function () {
        var toggleEditMode = _this.props.toggleEditMode;
        toggleEditMode({
          toggle: toggle
        });
      };
    }), _this.handleUpdateContent = function (editorState) {
      return _this.setState({
        editorState: editorState
      });
    }, _this.clearInput = function () {
      return _this.setState({
        editorState: _draftJs.EditorState.createEmpty()
      });
    }, _this.state = {
      editorState: _draftJs.EditorState.createEmpty()
    }, _this;
  }

  (0, _inherits2["default"])(Controls, _Component);

  var _super = _createSuper(Controls);

  return (0, _createClass2["default"])(Controls, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          editMode = _this$props.editMode,
          busy = _this$props.busy,
          comment = _this$props.comment,
          _this$props$comment = _this$props.comment,
          _this$props$comment$v = _this$props$comment.viewers,
          viewers = void 0 === _this$props$comment$v ? [] : _this$props$comment$v,
          createdByUser = _this$props$comment.createdByUser,
          _this$props$comment$c = _this$props$comment.children,
          children = void 0 === _this$props$comment$c ? [] : _this$props$comment$c,
          createReply = _this$props.createReply,
          handleUpdate = _this$props.handleUpdate,
          handleDelete = _this$props.handleDelete,
          canSave = _this$props.canSave,
          isReadOnly = _this$props.isReadOnly,
          resourceOrganisationId = _this$props.resourceOrganisationId,
          editorState = this.state.editorState,
          _getUser = (0, _utils.getUser)(createdByUser),
          isUser = _getUser.isUser;

      return _react["default"].createElement("div", {
        className: "comment-controls"
      }, _react["default"].createElement("div", {
        className: "comment-controls__container"
      }, editMode ? null : _react["default"].createElement(_react.Fragment, null, _react["default"].createElement(_Viewers["default"], {
        viewers: viewers
      }), isUser && !isReadOnly ? _react["default"].createElement("div", {
        className: "comment-controls__container__controls"
      }, _react["default"].createElement(_uiKit.Icon, {
        onClick: this.handleToggleEditMode({
          toggle: !0
        }),
        name: "edit",
        color: "regent",
        hoverColor: "black",
        disabled: !0,
        size: 15
      }), _react["default"].createElement(_uiKit.Icon, {
        onClick: handleDelete,
        name: "trash",
        color: "regent",
        hoverColor: "black",
        size: 15
      })) : null), editMode ? _react["default"].createElement("div", {
        className: "comment-controls__container__edit-comment-controls"
      }, _react["default"].createElement(_uiKit.LinkButton, {
        className: "comment-controls__container__edit-comment-controls__cancel",
        onClick: this.handleToggleEditMode({
          toggle: !1
        })
      }, "CANCEL"), _react["default"].createElement(_uiKit.Button, {
        className: "comment-controls__container__edit-comment-controls__save",
        onClick: handleUpdate,
        type: "SECONDARY",
        small: !0,
        busy: busy,
        disabled: !canSave
      }, "SAVE CHANGES")) : null), _react["default"].createElement(_AddReply["default"], {
        visible: !children.length && !isReadOnly,
        createReply: createReply,
        comment: comment,
        onUpdateContent: this.handleUpdateContent,
        editorState: editorState,
        clearInput: this.clearInput,
        resourceOrganisationId: resourceOrganisationId
      }));
    }
  }]), Controls;
}(_react.Component),
    _default = Controls;

exports["default"] = _default;